"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterValueSchema = void 0;
const zod_1 = require("zod");
exports.ParameterValueSchema = zod_1.z.object({
    units: zod_1.z.string(),
    value: zod_1.z.union([zod_1.z.boolean(), zod_1.z.number(), zod_1.z.string(), zod_1.z.number().array(), zod_1.z.string().array()]),
});
//# sourceMappingURL=ParameterValue.js.map